export function IconChevronLeft() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.786 0.528579C6.07401 0.819745 6.07086 1.28941 5.77924 1.57742L1.80026 5.50009L5.77924 9.42276C6.07085 9.71078 6.07401 10.1804 5.786 10.4716C5.49753 10.7632 5.02743 10.7664 4.73535 10.4784L0.220861 6.02791C0.079778 5.88864 -2.35629e-07 5.69842 -2.2696e-07 5.50011C-2.18292e-07 5.3018 0.0797794 5.11158 0.220861 4.97231L4.73535 0.521863C5.02741 0.233847 5.49753 0.236952 5.786 0.528579Z"
        fill="currentColor"
      />
    </svg>
  );
}
